import { Action } from 'infra/types'
import { ILoaders, IOutstandingReportState } from './outstandingReport.types'

export const outstandingReportActions = {
  setLoader: 'outstandingReport/setLoader',
  setDrawer: 'outstandingReport/setDrawer'
}

export const setLoaderAction = (payload: {
  id: keyof ILoaders
  value: boolean
}): Action<{ id: keyof ILoaders; value: boolean }> => ({
  type: outstandingReportActions.setLoader,
  payload
})

export const setDrawerAction = (payload: {
  drawerName: keyof IOutstandingReportState['drawers']
  status: boolean
}): Action<{
  drawerName: keyof IOutstandingReportState['drawers']
  status: boolean
}> => ({
  type: outstandingReportActions.setDrawer,
  payload
})
